import {RelativeFilterResponseBody, ReorderRelativeFiltersRequestBody} from '@dms/api/core';

export function buildReorderRelativeFiltersBody(
  orderedPresets: RelativeFilterResponseBody[]
): ReorderRelativeFiltersRequestBody {
  return {
    items: orderedPresets
      .map((preset, index) => ({preset, position: index + 1}))
      .filter(({preset}) => !preset.system)
      .map(({preset, position}) => ({
        id: preset.id,
        position,
      })),
  };
}
